import { RootState } from "@/store/Store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SlotInterface {
    id: string,
    time: string,
    date: string,
}

export interface DatesForEndCustomerStateInterface {
    slots: SlotInterface[],
}

function getInitialState() {
    const state: DatesForEndCustomerStateInterface = {
        slots: [],
    };
    return state;
}

export const DatesForTheEndCustomerSlice = createSlice({
    name: "DatesForTheEndCustomerSlice",
    initialState: getInitialState(),
    reducers: {
        addSlot: (state: DatesForEndCustomerStateInterface, action: PayloadAction<SlotInterface>) => {
            state.slots.push(action.payload);
        },
        removeSlot: (state: DatesForEndCustomerStateInterface, action: PayloadAction<SlotInterface["id"]>) => {
            state.slots = state.slots.filter(unit => unit.id !== action.payload);
        },
        clearSlots: (state: DatesForEndCustomerStateInterface, action: PayloadAction<void>) => {
            const initialState = getInitialState();
            state.slots = initialState.slots;
        },
    }
});

export const {
    addSlot,
    removeSlot,
    clearSlots,
} = DatesForTheEndCustomerSlice.actions;

export const getSelectorForValue = (name: keyof DatesForEndCustomerStateInterface) => (state: RootState) => state.datesForTheEndCustomer[name];

export const DatesForTheEndCustomerReducer = DatesForTheEndCustomerSlice.reducer;